import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { SEOHead } from '../components/common/SEOHead';

export const NotFoundPage = () => {
  return (
    <>
      <SEOHead
        title="Página no encontrada | REALimenta"
        description="La página que buscas no existe o ha sido movida."
        canonical="/404"
      />

      <section className="min-h-[70vh] flex items-center justify-center py-20">
        <div className="section-container text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <p className="text-8xl font-manrope font-extrabold text-brand-sage mb-4">404</p>
            <h1 className="font-manrope text-3xl md:text-4xl font-bold text-text-primary mb-4">
              Página no encontrada
            </h1>
            <p className="text-text-secondary text-lg mb-8 max-w-md mx-auto">
              La página que buscas no existe, ha sido movida o el enlace está incorrecto.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="btn-primary inline-flex items-center justify-center gap-2"
                data-testid="404-home-btn"
              >
                <Home className="w-5 h-5" />
                Ir al inicio
              </Link>
              <button
                onClick={() => window.history.back()}
                className="btn-outline inline-flex items-center justify-center gap-2"
                data-testid="404-back-btn"
              >
                <ArrowLeft className="w-5 h-5" />
                Volver atrás
              </button>
            </div>

            <div className="mt-12 p-6 bg-brand-sage/20 rounded-2xl max-w-md mx-auto">
              <p className="text-text-secondary text-sm">
                ¿Buscabas algo específico? Prueba en el{' '}
                <Link to="/blog" className="text-brand-primary hover:underline">blog</Link>
                {' '}o en las{' '}
                <Link to="/faq" className="text-brand-primary hover:underline">preguntas frecuentes</Link>.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default NotFoundPage;
